<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width="500" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-row(no-gutters)
        v-col(cols="10" offset="1")
          .text-xl.font-bold.text-center Dispense note
        v-col(cols="1" align="right")
          v-btn(icon @click="showDialog = false" small color="primary")
            v-icon mdi-close
    v-divider
    v-card-text.primary--text.pa-6
      div.text-sm.neutral700--text.pre-wrap {{ note }}

    v-divider
    v-card-actions.py-3.px-4
      v-spacer
      y-button(label="Close" size="sm" unset-min-width @click="showDialog = false")

</template>

<script>

export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
    note: {
      type: String,
      default: ''
    }
  },
  computed: {
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
}
</script>
